import type { TargetingDefinition, TargetingDefinitionAttributeMap } from '../../models';

export const GEO_CATEGORY_NAME: string = 'Geo';

export enum GeoDimension {
  Country = 'country',
  PostalCode = 'postal-code',
  City = 'city',
  DmaCode = 'dma-code',
  State = 'state',
}

enum ContentDimension {
  Movie = 'movie',
  Series = 'series',
  Extra = 'extra',
  Episode = 'episode',
  Season = 'season',
  Genre = 'genre',
}

export enum CustomDimension {
  Pod = 'pod',
  Publisher = 'publisher',
  Slot = 'slot',
  Age = 'age',
  TargetingPreset = 'PRESET',
}

export enum DemoDimension {
  Demo = 'demo',
  Audience = 'audience',
}

export const DIMENSIONS_TO_DISABLE = [DemoDimension.Audience];

// add dimensions here that should have mandatory filtering before loading dimension values
export const DIMENSIONS_DOES_NOT_SUPPORT_EMPTY_SEARCH: string[] = [];

export const DIMENSION_INCLUDE_EXCLUDE_LIST: string[] = [
  DemoDimension.Audience,
  ContentDimension.Genre,
  CustomDimension.TargetingPreset,
  GeoDimension.PostalCode,
  GeoDimension.City,
  GeoDimension.State,
  GeoDimension.DmaCode,
];

export const LINE_ITEM_DIMENSION_EXCLUSION_LIST: string[] = [CustomDimension.Publisher];

export const DROPDOWN_OPTIONS_IGNORED_DIMENSIONS = ['device-brand'];

export const PRESET_ID = 'PRESET';
export const PRESET_SUB_CLASS = 'com.disney.digital.ads.rule.manager.common.Preset';

export const PRESET_DISPLAY_NAME = 'Preset';

export const PRESET_SOURCE = {
  id: PRESET_ID,
  name: PRESET_ID,
  system: 'SELF',
  source: 'PRESET',
};

const EMPTY_ATTRIBUTE_MAP: TargetingDefinitionAttributeMap = {
  publisher: undefined,
  country: undefined,
  premiereDateTime: undefined,
  salesChannel: undefined,
  sportId: undefined,
  sportName: undefined,
};

export const PRESET_TARGETING_DIMENSION: TargetingDefinition = {
  id: PRESET_ID,
  name: PRESET_ID,
  displayName: PRESET_DISPLAY_NAME,
  primarySource: PRESET_SOURCE,
  additionalSource: [],
  attributeMap: EMPTY_ATTRIBUTE_MAP,
};

export const PRESET_TARGETING_DIMENTION_RESULT = {
  data: {
    nodes: [PRESET_TARGETING_DIMENSION],
    pageInfo: { hasNextPage: false, hasPreviousPage: false },
  },
  loading: false,
  loadingMore: false,
  error: undefined,
  refetch: (): Promise<void> => Promise.resolve(),
  reset: (): void => undefined,
};
